import { TestElement } from '@oracle/oraclejet-testing/UNSAFE_Driver';
import { byCss } from '@oracle/oraclejet-testing/UNSAFE_Locators';
import { TestAdapter } from '@oracle/oraclejet-testing/UNSAFE_TestAdapter';

type CardInputs = {
  card: TestElement;
  input: TestElement;
};

export class RichRadioSetAdapter extends TestAdapter {
  /**
   * Retrieves all cards and their corresponding inputs within the component.
   * @private
   * @returns Promise<CardInputs[]>
   */
  private async _getInputsWithCards(): Promise<CardInputs[]> {
    const el = await this.getElement();
    const cards = await el.waitForElements(byCss(`div[role="listitem"]`));

    return Promise.all(
      cards.map(async (card) => ({
        card,
        input: await card.waitForElement(byCss('input'))
      }))
    );
  }

  /**
   * Change the value of the component.
   * @param value {string | number} The new value.
   * @returns Promise<void>
   */
  async changeValue(value: number | string) {
    const driver = this.getTestDriver();
    const cardsAndInputs = await this._getInputsWithCards();

    await Promise.all(
      cardsAndInputs.map(async ({ card, input }) => {
        const inputValue = (await input.getAttribute('value')) ?? '';

        if (inputValue === value) {
          await driver.click(card);
        }
      })
    );
  }
}
